import React, {useEffect} from 'react';
import {matchPath} from 'react-router';
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {routes} from '../../../../../../core/models/static/routes/app-routes';
import useAccessLevels from '../../../../../hooks/use-access-levels';
import LoyaltyDashboardView from './dashboard';
import LoyaltyBuyView from './buy';
import LoyaltyRulesView from './rules';
import LoyaltyCustomersView from './customers';
import LoyaltySettingsView from './settings';

const BizPointLoyaltyViews = () => {
    const location = useLocation();
    const history = useHistory();
    const {packages} = useAccessLevels();

    /**
     * Redirect to the first available loyalty sub-section from the base path.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.bizPoint.loyalty.base, exact: true})) {
            if (packages.bizPoint.loyaltyDashboard) {
                history.replace(routes.bizPoint.loyalty.dashboard);
            } else if (packages.bizPoint.loyaltyBuyBiz) {
                history.replace(routes.bizPoint.loyalty.buy);
            } else if (packages.bizPoint.loyaltyEarningRules) {
                history.replace(routes.bizPoint.loyalty.rules);
            } else if (packages.bizPoint.loyaltyCustomers) {
                history.replace(routes.bizPoint.loyalty.customers);
            } else if (packages.bizPoint.loyaltySettings) {
                history.replace(routes.bizPoint.loyalty.settings);
            } else {
                history.replace(routes.bizPoint.loyalty.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [
        packages.bizPoint.loyaltyBuyBiz,
        packages.bizPoint.loyaltyCustomers,
        packages.bizPoint.loyaltyDashboard,
        packages.bizPoint.loyaltyEarningRules,
        packages.bizPoint.loyaltySettings,
        history,
        location.pathname,
    ]);

    return (
        <Switch>
            <Route path={routes.bizPoint.loyalty.base} exact/>
            {
                packages.bizPoint.loyaltyDashboard &&
                <Route path={routes.bizPoint.loyalty.dashboard} exact>
                    <LoyaltyDashboardView/>
                </Route>
            }
            {
                packages.bizPoint.loyaltyBuyBiz &&
                <Route path={routes.bizPoint.loyalty.buy} exact>
                    <LoyaltyBuyView/>
                </Route>
            }
            {
                packages.bizPoint.loyaltyEarningRules &&
                <Route path={routes.bizPoint.loyalty.rules} exact>
                    <LoyaltyRulesView/>
                </Route>
            }
            {
                packages.bizPoint.loyaltyCustomers &&
                <Route path={routes.bizPoint.loyalty.customers} exact>
                    <LoyaltyCustomersView/>
                </Route>
            }
            {
                packages.bizPoint.loyaltySettings &&
                <Route path={routes.bizPoint.loyalty.settings} exact>
                    <LoyaltySettingsView/>
                </Route>
            }
            <Redirect to={routes.bizPoint.loyalty.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default BizPointLoyaltyViews;
